import { Post } from 'generated-graphql';
import { ThirdParagraph } from '../../componentsWP/StyledComponentsLib/StyledComponentsLib';
import styles from './SeriesChapters.module.scss';
import Link from 'next/link';

const SeriesChapters = ({ series, seriesName }: { series: Post[], seriesName: string }) => {
  return (
    <div className={styles.chapters}>
      <ThirdParagraph>Parts to this series</ThirdParagraph>
      <ul>
        {series.map((s) => (
          <li key={s.id}><Link style={{ textDecoration: "none" }} href={`/resources/series/${seriesName}/${s.slug}`}>{s.title}</Link></li>
        ))}
      </ul>
    </div>
  );
};

export default SeriesChapters;
